import ArchivioEtichette from './ArchivioEtichette';

export default ArchivioEtichette;
